import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const InfoIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0_6509_150306"
        style={{ masktype: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <path d="M0 0H16V16H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_6509_150306)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.19445 6.5V12.1944H8.80556V6.5H7.19445ZM7.33889 4.03334C7.17964 4.18889 7.10001 4.38704 7.10001 4.62778C7.10001 4.87223 7.18149 5.07223 7.34445 5.22778C7.51112 5.38334 7.72964 5.46111 8.00001 5.46111C8.27038 5.46111 8.48704 5.38334 8.65001 5.22778C8.81667 5.07223 8.90001 4.87223 8.90001 4.62778C8.90001 4.38704 8.81852 4.18889 8.65556 4.03334C8.4926 3.87778 8.27408 3.8 8.00001 3.8C7.72223 3.8 7.50186 3.87778 7.33889 4.03334Z"
          fill="black"
          fillOpacity="0.54"
        />
      </g>
    </SvgIcon>
  );
});

<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
></svg>;
